

window.addEventListener('DOMContentLoaded', () => {
    console.log('Made with ❤️ by Atalanta')

    /**
     * Animation for loader
     */
    const pageLoader = document.querySelector('.loader')

    setTimeout( () => {
        pageLoader.classList.add('exit')
    }, 900)

    setTimeout( () => {
        pageLoader.classList.add('loaded')
    }, 1600)



    // backtotop
    var btnTop = jQuery('#button-top');
    var btn = jQuery('#button');

    jQuery(window).scroll(function() {
        if (jQuery(window).scrollTop() > 300) {
            btnTop.addClass('show');
        } else {
            btnTop.removeClass('show');
        }
        if (jQuery(window).scrollTop() + jQuery(window).height() > jQuery(document).height() - 450) {
            btnTop.addClass('bottom');
        } else {
            btnTop.removeClass('bottom');
        }
    });


    btn.on('click', function(e) {
        e.preventDefault();
        jQuery('html, body').animate({scrollTop:0}, '450');
    });

    // list-product-fixed
    var pnButtons = jQuery('.prev_next_buttons');
    var navFixed = jQuery('#nav-fixed');

    jQuery(window).scroll(function() {
        if (jQuery(window).scrollTop() > 0) {
            pnButtons.addClass('show');
            navFixed.addClass('show');
        } else {
            pnButtons.removeClass('show');
            navFixed.removeClass('show');
        }
        if (jQuery(window).scrollTop() + jQuery(window).height() > jQuery(document).height() - 450) {
            pnButtons.addClass('bottom');
            navFixed.addClass('bottom');
        } else {
            pnButtons.removeClass('bottom');
            navFixed.removeClass('bottom');
        }
    });


    btn.on('click', function(e) {
        e.preventDefault();
        jQuery('html, body').animate({scrollTop:0}, '450');
    });

    // add numbering for article on homepage for grid
    jQuery(".list-categories-item").each(function(i){
        jQuery(this).addClass("item-" +(i + 1));
    });


})


// ------------------------------------
// Import SCSS files
// ------------------------------------

import "../sass/main.scss";

// ------------------------------------
// Import scripts
// ------------------------------------

import "./components/woo"
import "./components/home"
import "./components/page"
import "./components/header"
// import "./ajax-add-to-cart"
// import "./components/backto"






